module.exports = __webpack_public_path__ + "static/media/screen5-mini-2x.a0d5d094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Phone/screen5-mini-2x.jpg
// module id = 52
// module chunks = 0